module.exports = __webpack_public_path__ + "img/i_h2_hiyoko.99e47cf0.svg";